module.exports = __webpack_public_path__ + "static/media/Element_12_treatments.58ec8477.svg";